const FamilyList = (props) => {
  const { data } = props;

  return (
    <>
      {data.slice(0, 19).map((item) => {
        return (
          <div className="family-item" key={item._id}>
            <a
              href={`/family/${item._id}`}
              target="familyinfo"
              title={item.family_name}
            >
              <img src={item.family_pic} alt="" />
            </a>
            <div className="family-item-info">
              <a
                href={`/family/${item._id}`}
                target="familyinfo"
                className="text-overflow family-item-name"
                title={item.family_name}
              >
                {item.family_name}
              </a>
              <span className="text-overflow family-item-member">
                族长：{item.leader_nick_name}
              </span>
              <br />
              <div className="fix">
                <span
                  className="iconfont icon-rentouxiang"
                  title="成员数"
                ></span>
                <span className="family-item-user">{item.member_count}人</span>
                <span
                  className="iconfont icon-zhuborenshu"
                  title="主播数"
                ></span>
                <span className="family-item-user">
                  {item.star_count || 0}人
                </span>
              </div>
              <span
                className={`familyIcon ${
                  item.week_support ? ' familyFirstIcon' : ''
                }`}
                title={item.badge_name}
              >
                {item.badge_name}
              </span>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FamilyList;
